<template>
	<div>
		<div class="container-fluid">
			<nav class="navbar navbar-expand-lg navbar-light mb-4 mt-2">
				<h1 class="h3 mb-0 text-gray-800 mr-4">
					Despesas
			  	</h1>
			  	<button
					class="navbar-toggler"
					type="button"
					data-toggle="collapse"
					data-target="#navbarFinanceiroGeral"
					aria-controls="navbarFinanceiroGeral"
					aria-expanded="false"
					aria-label="Toggle navigation">
			    	<span class="navbar-toggler-icon"></span>
			  	</button>
			  	<div class="collapse navbar-collapse mt-4" id="navbarFinanceiroGeral">
			  		<div class="mr-auto">
						<div class="form-group col-md-12">
							<input-date
								time="1000"
								@date="setDate">
							</input-date>
						</div>
					</div>
					<div class="row">
						<div class="mr-1 mb-2">
							<router-link
		                        class="btn btn-primary"
		                        v-bind:to="{ name: 'unidadeMedida' }">
		                        Unidades de Medida
		                    </router-link>
		                </div>
		                <div class="mb-2 mr-1">
							<router-link
		                        class="btn btn-primary"
		                        v-bind:to="{ name: 'despesaCategoria' }">
		                        Categorias
		                    </router-link>
		                </div>
		                <div class="mb-2">
							<button
								class="btn btn-danger"
								@click="create()">
								Nova Despesa
							</button>
						</div>
					</div>
			  	</div>
			</nav>
			<!-- Totais -->
			<despesa-total
				v-if="date"
				:key="chartDespesaKey"
				:date="date">
			</despesa-total>
			<!-- Chart -->
			<div class="row mt-4">
				<div class="col-md-12">
					<despesa-chart
						v-if="date"
						:date="date"
						:key="chartDespesaKey">
					</despesa-chart>
				</div>
			</div>
			<despesas-categoria-card
				v-if="date"
				:date="date"
				:key="despesasCategoriaCardKey">
			</despesas-categoria-card>
			<despesa-card
				v-if="date"
				:date="date"
				:despesaTableKey="despesaTableKey"
				@show="show">
			</despesa-card>
		</div>
		<despesa-create
			:key="despesaTableKey"
			@reload="reload">
		</despesa-create>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				dado_id: 0,
				date: '',
				despesaTableKey: 0,
				chartDespesaKey: 1,
				despesasCategoriaCardKey: 2
			}
		},
		methods: {
			setDate(date){
				this.date = date;
				this.reload();
			},
			create(){
				$('#create_despesa').modal('show');
			},
			reload(){
				this.despesaTableKey += 1;
				this.chartDespesaKey += 1;
				this.despesasCategoriaCardKey++;
			},
			show(dado_id){
				this.$router.push('/adm/despesas/show/'+dado_id)
			}
		}
	}
</script>
